/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileSchemaIn } from './FileSchemaIn';
import {
    FileSchemaInFromJSON,
    FileSchemaInFromJSONTyped,
    FileSchemaInToJSON,
} from './FileSchemaIn';

/**
 * 
 * @export
 * @interface DoctorSignupStep5
 */
export interface DoctorSignupStep5 {
    /**
     * 
     * @type {FileSchemaIn}
     * @memberof DoctorSignupStep5
     */
    clinicOutsidePhoto?: FileSchemaIn;
    /**
     * 
     * @type {FileSchemaIn}
     * @memberof DoctorSignupStep5
     */
    clinicInsidePhoto?: FileSchemaIn;
}

/**
 * Check if a given object implements the DoctorSignupStep5 interface.
 */
export function instanceOfDoctorSignupStep5(value: object): boolean {
    return true;
}

export function DoctorSignupStep5FromJSON(json: any): DoctorSignupStep5 {
    return DoctorSignupStep5FromJSONTyped(json, false);
}

export function DoctorSignupStep5FromJSONTyped(json: any, ignoreDiscriminator: boolean): DoctorSignupStep5 {
    if (json == null) {
        return json;
    }
    return {
        
        'clinicOutsidePhoto': json['clinic_outside_photo'] == null ? undefined : FileSchemaInFromJSON(json['clinic_outside_photo']),
        'clinicInsidePhoto': json['clinic_inside_photo'] == null ? undefined : FileSchemaInFromJSON(json['clinic_inside_photo']),
    };
}

export function DoctorSignupStep5ToJSON(value?: DoctorSignupStep5 | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clinic_outside_photo': FileSchemaInToJSON(value['clinicOutsidePhoto']),
        'clinic_inside_photo': FileSchemaInToJSON(value['clinicInsidePhoto']),
    };
}

